Theme.ComponentCollections.MenuDropdowns = (function () {
  const collection = new Theme.ComponentCollection("component-menu-dropdown");

  hide_on_click();
  hide_on_scroll();
  hide_on_resize();

  function hide_on_click() {
    document.addEventListener("click", (event) => {
      if (!event.target.closest("component-menu-dropdown")) {
        hide();
      }
    });
  }

  function hide_on_scroll() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          hide();
        }
      });
    }, { threshold: 0.1 });

    collection.elements.forEach(element => {
      observer.observe(element);
    });
  }

  function hide_on_resize() {
    const mediaQuery = window.matchMedia("(max-width: 1023px)");

    mediaQuery.addEventListener("change", (event) => {
      if (event.matches) {
        hide();
      }
    });
  }

  function hide(options) {
    const except = options && options.except;

    collection.elements.forEach(element => {
      if (element !== except) {
        element.hide();
      }
    });
  }

  return {
    hide
  }
})();

class ComponentMenuDropdown extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      "dropdown": ".menu-dropdown",
      "trigger": ".nav-caret"
    });

    this.collection = Theme.ComponentCollections.MenuDropdowns;
  }

  connectedCallback() {
    this.events();

    this.addEventListener("mouseenter", () => {
      this.show().then(() => {
        this.collection.hide({ except: this });
      });
    });

    this.addEventListener("mouseleave", (e) => {
      if (!this.contains(e.relatedTarget)) {
        setTimeout(() => {
          if (!this.matches(":hover")) this.hide();
        }, 150);
      }
    });

    this.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.classList.contains("active--true")) {
        this.hide();
        this.elements.trigger?.focus();
      }
    });

    this.addEventListener("focusout", (e) => {
      if (!this.contains(e.relatedTarget)) {
        this.hide();
      }
    });
  }

  toggle() {
    if (this.classList.contains("active--true")) {
      this.hide();
    } else {
      this.show().then(() => {
        this.collection.hide({ except: this });
      });
    }
  }

  hide() {
    if (!this.classList.contains("active--true")) {
      return;
    }

    this.classList.remove("active--true");
    this.elements.trigger?.setAttribute("aria-expanded", "false");
    this.elements.dropdown.style.opacity = "0";

    this.elements.dropdown.addEventListener("transitionend", () => {
      if (!this.classList.contains("active--true")) {
        this.elements.dropdown.style.display = "none";
      }
    }, { once: true });
  }

  show() {
    this.elements.dropdown.style.display = "block";
    this.elements.trigger?.setAttribute("aria-expanded", "true");

    if (this.elements.dropdown.classList.contains("menu-dropdown-b")) {
      const nav = this.closest(".navigation");

      if (nav) {
        const offset = this.getBoundingClientRect().left - nav.getBoundingClientRect().left;
        this.elements.dropdown.style.left = `${offset}px`;
      }
    }

    return new Promise(resolve => {
      requestAnimationFrame(() => {
        this.elements.dropdown.style.opacity = "1";
        this.classList.add("active--true");

        setTimeout(() => {
          resolve();
        }, 150);
      });
    });
  }
}

customElements.define("component-menu-dropdown", ComponentMenuDropdown);